import React, { useEffect, useState, Component } from "react";
import { useRouter } from "next/compat/router";
import { BuilderComponent, useIsPreviewing } from "@builder.io/react";
import Head from "next/head";
import dynamic from 'next/dynamic'
import {
  viewCollection,
  viewFrontPage,
  viewNotFound,
} from "@/components/common/Nosto";
import { useDispatch, useSelector } from "react-redux";
import { setMenuData } from "@/redux/actions/generalAction";
// import Collection from "@/components/PLP-2.0/collection";
const Collection = dynamic(() => import('@/components/PLP-2.0/collection'))
import { isCurrentPageStatic, fetchBuilderContent, fetchPagesByURL, fetchServerState, isValidCollection, fetchPageSEOData, fetchBuilderContentModel, getShopifyIndexByServerPath, fetchCachedServerState } from "../utils/pages"
import { removeTargetAttr } from "@/helpers/generalHelper";
import { reportError } from "@/helpers/errorHelper";
import { getPaginationParamsByPageNo } from "@/components/PLP-2.0/pagination-utils";

export async function getServerSideProps({ req, res, resolvedUrl, query }) {
  // res.setHeader(
  //   'Cache-Control',
  //   'public, s-maxage=3600, stale-while-revalidate=59'
  // )
  const substring = 'Mobile';
  const app = req?.cookies?.isApp ? true : false

  let pageURL = req.url;
  if (pageURL.includes('.json')) {
    /* While using react Link it will add .json file. By using resolveURL we will get actual path */
    pageURL = resolvedUrl;
  }
  pageURL = pageURL.split('/index.')[0];
  pageURL = pageURL;

  // Check if the page URL does not include '/women/clothing'
  if (!pageURL.includes('/women/clothing')) {
    // Ensure the code runs only in the browser environment
    if (typeof window !== 'undefined') {
      // Remove the 'searchText' item from sessionStorage
      sessionStorage.removeItem('searchText');
    }
  }

  const isMobile = req?.rawHeaders.some(item => item.includes(substring));
  if (isValidCollection(pageURL)) {
    //only when the urser will go to PLP via the Oli popup the url will have oli as query param
    let oliSearch = false;
    if(pageURL.includes('search_source=oli_plp')){
      oliSearch = true;
    }
    const protocol = req.headers.referer?.split("://")[0] || "https";
    const serverUrl = `${protocol}://${req.headers.host}${pageURL}`;
    const serverPath = pageURL;
    const contentTilePLP1 = await fetchBuilderContentModel(pageURL, "content-tile-plp",app);
    const contentTilePLP2 = await fetchBuilderContentModel(pageURL, "content-tile-plp-2",app);
    const imageQuickLinks = await fetchBuilderContentModel(pageURL, "image-quick-links",app); 
    const seoData = await fetchBuilderContentModel(pageURL.split('?')[0], 'seo');
    let serverState;
    // get offset or length for the given page when containg a page parameter in url is reloaded
    // this is used to get correct page data during server side rendering
    const { offset, length } = getPaginationParamsByPageNo({ page: query.page ? parseInt(query.page) : 1 } ,{ enableContentTile: contentTilePLP1 || contentTilePLP2 ? true : false }, true)
    //OS-5574 removed the code for plp caching for mobile
    // if(isMobile)
    // {
    //   serverState = await fetchCachedServerState(serverUrl, serverPath, isMobile);
    // } else {
      serverState = await fetchServerState(serverUrl, serverPath, isMobile, offset, length, seoData?.data, oliSearch);
    //} 

    let nbHitsResult;
      try {
        nbHitsResult = serverState?.initialResults[getShopifyIndexByServerPath(serverPath)]?.results[0]?.nbHits;
      }
      catch (error) {
        reportError("Algolia result object is changed")
        reportError(error)
      }
      if (nbHitsResult === 0) {
        return {
          notFound: true,
        }
      }
    const menuElement = await fetchBuilderContent(false, pageURL,'menuElement');
    return {
      props: {
        page: null,
        menuElement: menuElement,
        isStaticPage: false,
        serverState,
        serverUrl,
        serverPath,
        notFound: false,
        contentTilePLPOne: contentTilePLP1,
        contentTilePLPTwo: contentTilePLP2,
        quickLinks : imageQuickLinks,
        seoData: seoData,
        isMobile: isMobile,
        nbHits: nbHitsResult,
        offset: offset,
        length: length,
        oliSearch: oliSearch
      },
    }
  }
  
  const isStaticPage = await fetchPagesByURL(pageURL.split("?")[0],pageURL);
  const skipUrls = ["/cartjs","/loggedincustomer"] 

  if (isStaticPage || skipUrls.includes(pageURL)) {
    // Fetch the pages from Page URL
    const pages = isStaticPage;
    const isImpactOrCharityPage =
      pageURL.startsWith("/impact") ||
      pageURL.startsWith("/charity");

    // Fetch the builder content
    const menuElement = await fetchBuilderContent(isImpactOrCharityPage, pageURL,'menuElement')
    return {
      props: {
        page: pages || null,
        menuElement: menuElement,
        isStaticPage: true,
        serverPath: pageURL,
        notFound: false
      },
    }
  }

  // if the page is not static and not a valid collection, render 404 page

  return {
    notFound: true,
  }
}

export default function Page(props) {
  const { page, menuElement, isStaticPage, serverState, serverUrl, serverPath, contentTilePLPOne, contentTilePLPTwo, seoData, isMobile, offset, length, nbHits, quickLinks, oliSearch } = props;
  const router = useRouter();
  const isPreviewing = useIsPreviewing();
  const dispatch = useDispatch();
  const [isClient, setIsClient] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  if (menuElement) {
    dispatch(setMenuData(JSON.stringify(menuElement)));
  }


  // triggering viewFrontPage & viewCollection based on the type of page
  useEffect(() => {
    setIsClient(true);

    if (isPreviewing) {
    }
    else if (isStaticPage) {
      viewFrontPage();
    }
    else if (serverUrl) {
      let { pages = [] } = router.query;
      let params = pages.map((s) => decodeURI(s));
      viewCollection({ collectionPath: params[1] || decodeURI(router.pathname.split("/")[1]) });
    }
    else {
      viewNotFound();
    }

  }, [])

  if (isClient) {
    removeTargetAttr();
  }
  
  var seoDataa = {};
  if (seoData?.data) {
    seoDataa = seoData.data;
  }
  // // fetch SEO data for a given page
  const { pageTitle, seoPageTitle, seoDescription } = fetchPageSEOData(page)
  // Canonical URL checks if  its a homepage it will references the primary URL else it will append routerpath to the baseURL
  // split("?")= basically clean up the Url Parameter like "?query="
  const canonicalUrl = (`${process.env.NETLIFY_URL}` + (router.asPath === "/" ? "" : router.asPath)).split("?")[0];

  return (
    <>
      {/* Render the Builder page */}
      <Head>
        <title>{pageTitle}</title>
        <meta name="title" content={seoPageTitle} />
        <meta name="description" content={seoDescription} />
        <meta property="og:title" content={seoPageTitle}></meta>
        <meta property="og:description" content={seoDescription}></meta>
        <meta property="og:url" content={`${process.env.NETLIFY_URL}${page?.data?.url} `}></meta>
        <meta property="og:image" content={`${process.env.NETLIFY_URL} /${process.env.OG_IMAGE_PATH}`}></meta >
        <meta property="og:image:secure_url" content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="628"></meta>
        {/* canonical links basically helps to  prevent parameters to appear on Google search results and also improves SEO */}
        <link rel="canonical" href={canonicalUrl} />
      </Head >
      {/* render Collection if the page is of collection type else render Builder Component */}
      {
        !isStaticPage ? (
          <Collection serverRender={false} serverState={serverState} serverUrl={serverUrl} serverPath={serverPath} contentTilePLPOne={contentTilePLPOne} contentTilePLPTwo={contentTilePLPTwo} seoDataa={seoDataa} isMobile={isMobile} offset={offset} length={length} nbHits={nbHits} quickLinks={quickLinks} oliSearch={oliSearch}/>
        ) : (
        <BuilderComponent model="page" content={page} />
        )
      }
    </>
  );
}
